/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const UpdateEmailRequest = zod
	.object({
		current_password: zod.string().describe('Current password'),
		user: zod.object({
			email: zod.email().optional().describe('New email address')
		})
	})
	.describe('Update email request body');

export type UpdateEmailRequest = zod.input<typeof UpdateEmailRequest>;
export type UpdateEmailRequestOutput = zod.output<typeof UpdateEmailRequest>;
